import {Part} from "../part";
import {toiletThumbnail} from '../../../bvComponent/core/assets';
import {PartMenuType} from "../../../visComponents/constants";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {IntermediatePart} from "../intermediatePart";
import {removeLookPointFor} from "../../lookNavigation/lookFunctions2";
import {getCurrentRoomType} from "../../../appLayout";
import {LOOK_ROOM_TYPES} from "../constants";

export class Toilet extends Part {
  static id = 'Toilet';

  constructor() {
    super(true, false, PartMenuType.Complex);
    this.menuType = PartMenuType.Complex;
    this.partName = 'Toilet';
    this.translateId = "visualizer.bathroom.toilet";
    this.homePageTitle = 'Toilets';
    this.partThumbnail = toiletThumbnail;
    this.toilet = null;
    this.relatedGroupNames = ["Toilet"];
  }

  load(dbFeature, loadFeature = true) {
    if (dbFeature.groupName === "Toilet") {
      if (!this.toilet) {
        this.toilet = new ToiletBody(true);
        this.relatedItems.push(this.toilet);
        this.toilet.getParent = () => this;
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      if (loadFeature) {
        this.toilet.load(dbFeature);
      }
      return true
    }
    return false
  }

  isSubTypeWithItems() {
    return false;
  }

  subParts() {
    return this.relatedItems.map(_ => new DesignNavigationItem(_.partName, _));
  }

  setDefaultPartAfterSubTypeClick() {
    return this.subParts()[0]
  }

  setDefault(layout) {
    this.relatedItems.forEach(_ => _.setDefault(layout));
  }
}

class ToiletBody extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'toilet';
    this.partName = 'Toilet';
    this.translateId = "visualizer.bathroom.toilet";
    this.homePageTitle = 'Toilets';
    this.canBeDisabled = true;
  }

  // getArrayOfConditions() {
  //   let conditions = super.getArrayOfConditions(); //roomLayout
  //   const layout = this.getParent().layout;
  //   const showerParent = layout.parts[Shower.id];
  //   const showerSize = showerParent.showerSize();
  //   if (showerParent && showerSize && !IS_BATHROOM_OLD_BV_SCENE) {
  //     conditions.push({
  //       propName: "ShowerSize",
  //       propValue: showerSize
  //     });
  //   }
  //   return conditions
  // }

  canDisplayDemoPoint(parentObject) {
    if (getCurrentRoomType() === LOOK_ROOM_TYPES.as) {
      return removeLookPointFor(parentObject, 6, "1")
    }
    return true
  }
}


